module.exports = __webpack_public_path__ + "static/media/ai-banner-avatar-1.12b7518e.webp";